import React from "react";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import OrientationFormPresenter from "./OrientationFormPresenter";
import OrientationAgreement from "../components/OrientationAgreement";
import { companyRules1, companyRules2 } from "./companyRules";
import DialogSuccess from "../../../my-listings/components/DialogSuccess";
import { dialog, printComponent } from "../../../../nq-component";
import { footer } from "framer-motion/client";
import NavBar from "../../../../components/navbar";
import OrientationForm from "./OrientationForm";

class OrientationFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      isAddressSame: false,
      employmentForm: [],
    };
    this.presenter = new OrientationFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );

    this.consentPDF = React.createRef();
  }

  getCollectionName() {
    const typeOfApplication = this.getApplicationType();
    switch (typeOfApplication) {
      case "online":
        return "online_applicants";
        break;
      case "walkIn":
        return "walkIn_applicants";
        break;
      default:
        return "reprocess_applicants";
        break;
    }
  }

  getApplicationType() {
    return this.props.params.type;
  }

  onSave(termsAgreed, signature) {
    this.presenter.onSave(termsAgreed, signature);
  }

  showSuccess(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  exportPDF() {
    printComponent(this.consentPDF.current);
  }

  onClickPrint() {
    this.presenter.onClickPrint();
  }
  render() {
    const { object } = this.state;
    const reminder =
      "*Reminder: All Non-negotiable requirements are required to RENEW every MARCH of the year.";
    const user = this.getCurrentUser();

    return (
      <>
        <div className="d-none">
          <div ref={this.consentPDF}>
            <OrientationForm object={object} />
          </div>
        </div>
        <NavBar user={user} />
        <div className="mt-4 p-4 pt-3 d-flex flex-column gap-2 container">
          <div className="d-flex justify-content-between">
            <div className="d-flex gap-4">
              <p
                className="cursor-pointer m-0"
                onClick={() => window.history.back()}
              >
                <i
                  class="bi bi-arrow-left fs-4"
                  style={{ color: `#303030CC` }}
                ></i>
              </p>
              <h1 className="fs-2 fw-bold m-0" style={{ color: `#D18237` }}>
                Orientation Form
              </h1>
            </div>
            <button
              className="btn text-white fw-bold"
              style={{ backgroundColor: "#3174ad" }}
              onClick={this.onClickPrint.bind(this)}
            >
              <i class="bi bi-printer me-2"></i>
              Print Orientation Form
            </button>{" "}
          </div>
          <div className="p-4 mt-2 px-5 bg-white border rounded shadow-sm d-flex flex-column">
            <img
              src="/lgsnobg.png"
              alt="LGS Logo"
              className="mb-3"
              style={{ maxWidth: "300px", alignSelf: "center" }}
            />
            <p
              className="fw-bold text-center border border-dark border-2 py-2 mb-4 align-self-center"
              style={{ width: "60%" }}
            >
              COMPANY RULES AND PROCEDURES FOR NEW EMPLOYEE
            </p>
            {companyRules1.map((companyRule, index) => (
              <div key={index}>
                <div className="d-flex gap-3">
                  <p className="fw-bold">{index + 1}.</p>
                  <p>{companyRule}</p>
                </div>

                {index === 0 && <p className="ms-3">{reminder}</p>}
              </div>
            ))}
          </div>

          <div className="p-4 px-5 bg-white border rounded shadow-sm d-flex flex-column">
            {/* <img
              src="/lgsnobg.png"
              alt="LGS Logo"
              className="mb-3"
              style={{ maxWidth: "300px", alignSelf: "center" }}
            /> */}
            {companyRules2.map((companyRule, index) => (
              <div key={index}>
                <div className="d-flex gap-3">
                  <p className="fw-bold">{index + 16}.</p>
                  <p>{companyRule}</p>
                </div>
              </div>
            ))}
          </div>

          <OrientationAgreement
            object={object}
            onSave={this.onSave.bind(this)}
          />
        </div>
      </>
    );
  }
}

export default withRouter(OrientationFormPage);
